import React from 'react';

import { ExperienceEntityType, PageHeader, useExperienceModuleContext } from 'modules/experience-core';
import { MessagePage } from 'modules/experience-core';

import { WoltCapitalOffer } from './WoltCapital';

export const ExperienceWoltCapital = () => {
  const {
    experienceEntity: { experienceEntityType, experienceEntityId },
  } = useExperienceModuleContext();

  if (experienceEntityType === ExperienceEntityType.MERCHANT) {
    return (
      <>
        <PageHeader enableSelector={false} />
        <WoltCapitalOffer merchantId={experienceEntityId} />{' '}
      </>
    );
  }

  return <MessagePage variant="not_supported" />;
};
